import { useState } from 'react';
import { Link } from '@framework/router/Next/Link';
import useResponsive from '@dealroadshow/uikit-hooks/useResponsive';
import screenVariables from '@dealroadshow/uikit-styles/variables/screen.module';
import IconArrowDown from '@creditflowresearch/uilib/Icon/IconArrowDown';
import IconArrowUp from '@creditflowresearch/uilib/Icon/IconArrowUp';
import Links from '@creditflowresearch/uilib/Links';
import Flex from '@creditflowresearch/uilib/Flex';
import Menu, { MenuItem, MenuItemType } from '@creditflowresearch/uilib/Menu';
import { useAiSidebarContext } from '@/creditflowresearch/application/AiSidebar/AiSidebarContext';
import headerLinksConfig from './headerLinksConfig';

import styles from './headerLinks.module.scss';

const HeaderLinks = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { width: sidebarWidth } = useAiSidebarContext();

  const isCompact = useResponsive(({ width }) => width - sidebarWidth < parseInt(screenVariables.screen1126));

  if (!isCompact) {
    return <Links config={ headerLinksConfig } />;
  }

  return (
    <Menu
      open={ isOpen }
      setOpen={ setIsOpen }
      placement="bottom-end"
      closeOnItemClick
      contentClassName={ styles.menu }
      dataTest="headerMoreMenu"
      trigger={ ({ referenceProps }) => (
        <button
          type="button"
          className={ styles.trigger }
          data-test="headerMoreButton"
          { ...referenceProps }
        >
          <Flex align="center" gap={ 10 }>
            More
            { isOpen
              ? <IconArrowUp className={ styles.arrow } />
              : <IconArrowDown className={ styles.arrow } /> }
          </Flex>
        </button>
      ) }
    >
      { headerLinksConfig.map(({ url, dataTest, label, target }) => (
        <MenuItem
          key={ url }
          type={ MenuItemType.navLink }
          LinkComponent={ Link }
          to={ url }
          target={ target }
          textClassName={ styles.label }
          dataTest={ dataTest }
        >
          { label }
        </MenuItem>
      )) }
    </Menu>
  );
};

export default HeaderLinks;
